import 'core-js/stable'
import 'regenerator-runtime/runtime'

/*
Here we can place polyfills, that are not provided by babel.
These are mostly DOM Polyfills.
*/
if (typeof Element !== 'undefined' && Element && Element.prototype && !Element.prototype.remove) {
  // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
  ;(function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('remove')) { //eslint-disable-line
        return
      }
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          if (this.parentNode === null) {
            return
          }
          this.parentNode.removeChild(this)
        }
      })
    })
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype])
}

if (
  typeof HTMLFormElement !== 'undefined' &&
  HTMLFormElement &&
  HTMLFormElement.prototype &&
  !HTMLFormElement.prototype.reportValidity
) {
  HTMLFormElement.prototype.reportValidity = function reportValidity() {
    if (this.checkValidity && this.checkValidity()) return true
    //TODO: Create proper polyfill for reporting validity of forms/formelements
    /*const isForm = this.tagName === 'FORM';
    const isFormElement = !!this.form;*/

    return false
  }
}
